import request from '@/utils/request'

export function saveAreaAppealType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppealType.saveAreaAppealType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存分类失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateAreaAppealType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppealType.updateAreaAppealType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新分类失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteAreaAppealType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppealType.deleteAreaAppealType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除分类失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAreaAppealTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityAppealType.listAreaAppealType',
      method: 'get',
      params: {
        ...params,
        page: params.page - 1
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
